jQuery(document).ready(function($) {
	jQuery('.corvus_marker').hover(function() {

    	var location_id = jQuery(this).attr('data-location-id');
    	var location_description = jQuery(this).attr('data-location-description');

    	jQuery('#corvus_marker_hover_html').html(location_description);

    	var coords_marker = jQuery(this).position();

	    jQuery('#corvus_marker_hover_html').css({
	    	display: 'block',
	    	top: coords_marker.top+20,
	    	left: coords_marker.left
	    });

  	}, function() {

    	jQuery('#butikk_html').html(' ');
    	jQuery('#corvus_marker_hover_html').css({
    		display: 'none',
    	});

  	});

  	jQuery('.corvus_marker').click(function(event) {
    	var location_id = jQuery(this).attr('data-location-id');
    	//Scroll to location
  	});
  	
});
